(function ($, document, ns) {

    function ShowReport(report) {
        ns.ShowModal(function () {
            return Mustache.render(ns.Templates.ConditionReport, report);
        });
    }

    ns.Templates = ns.Templates || {};

    $(document).ready(function () {

        $(document).on('click', '.js-modal-condition-report', function (e) {
            e.preventDefault();
            var $link = $(this);
            var report = {};
            report.ConditionImage = $link.data('condition-image');
            report.Packaging = $link.data('condition-packaging');
            report.Provenance = $link.data('condition-provenance');
            report.ProductTitle = $link.data('product-title');
            report.StockCert = $link.data('condition-stock-cert');
            report.DownloadConditionImage = $link.data('condition-download-image');
            report.ConditionImageDate = $link.data('condition-image-date');
            report.Comments = $link.data('condition-comments');

            if (ns.Templates.ConditionReport) {
                ShowReport(report);
            } else {
                $.when(
                    $.get('/CMSGlobalFiles/mustache/modal-condition-report.mustache')
                ).done(function (template) {
                    ns.Templates.ConditionReport = template;
                    ShowReport(report);
                });
            }
        });

        $('.js_reportModal').click(function () {
            var imgSrc = $(this).attr('data-image');
            $('#reportModal img').attr("src", imgSrc);
            $('#reportModal').foundation('reveal', 'open');
        });
    });
})(jQuery, document, Crafted.Utilities);